import { Injectable } from '@angular/core';
import { GlobalConfig } from '../../../shared/configs/global-config';

export const USER_KEY = 'user';
export const ORGANIZACAO_ATIVA_KEY = 'organizacao_ativa_id';
export const ORGANIZACOES_HIDRATADAS_KEY = 'organizacoes_hidratadas';

export function resolveOrganizacaoAtiva(user: any, idEscolhido?: string) {
  const organizacoes = user?.organizacoes ?? [];
  if (!organizacoes.length) return null;

  const escolhida = idEscolhido
    ? organizacoes.find((organizacao) => organizacao?.id === idEscolhido)
    : null;

  return (
    escolhida ??
    organizacoes.find((organizacao) => organizacao?.padrao) ??
    organizacoes[0]
  );
}

export function readOrganizacaoAtivaId(): string | null {
  try {
    const user = JSON.parse(window.localStorage.getItem(USER_KEY));
    const idEscolhido = window.localStorage.getItem(ORGANIZACAO_ATIVA_KEY);
    return resolveOrganizacaoAtiva(user, idEscolhido)?.id ?? null;
  } catch {
    return null;
  }
}

@Injectable()
export class LocalStorageService {
  constructor() {}

  set(key, value) {
    window.localStorage[key] = value;
  }

  get(key, defaultValue = null) {
    return window.localStorage[key] || defaultValue;
  }

  setObject(key, value: Object) {
    this.set(key, JSON.stringify(value));
  }

  getObject(key) {
    return JSON.parse(window.localStorage.getItem(key));
  }

  remove(key) {
    window.localStorage.removeItem(key);
  }

  getUser() {
    let user = this.getObject(USER_KEY);
    if (!user) return;
    return user;
  }

  getOrganizacoes() {
    let user = this.getObject(USER_KEY);
    if (!user) return [];
    return user.organizacoes ?? [];
  }

  getOrganizacaoAtiva() {
    return resolveOrganizacaoAtiva(
      this.getObject(USER_KEY),
      this.get(ORGANIZACAO_ATIVA_KEY)
    );
  }

  setOrganizacaoAtivaId(organizacaoId: string) {
    this.set(ORGANIZACAO_ATIVA_KEY, organizacaoId);
  }

  patchOrganizacaoAtiva(patch: Object) {
    const user = this.getObject(USER_KEY);
    const organizacao = resolveOrganizacaoAtiva(user, this.get(ORGANIZACAO_ATIVA_KEY));
    if (!organizacao) return;

    Object.assign(organizacao, patch);
    this.setObject(USER_KEY, user);

    return user;
  }

  removeOrganizacaoAtivaId() {
    this.remove(ORGANIZACAO_ATIVA_KEY);
  }

  getOrganizacoesHidratadas(): boolean {
    return this.get(ORGANIZACOES_HIDRATADAS_KEY) === 'true';
  }

  setOrganizacoesHidratadas() {
    this.set(ORGANIZACOES_HIDRATADAS_KEY, 'true');
  }

  removeOrganizacoesHidratadas() {
    this.remove(ORGANIZACOES_HIDRATADAS_KEY);
  }

  getOrganizacaoId() {
    return this.getOrganizacaoAtiva()?.id;
  }

  getOrganizacaoPlanoId() {
    return this.getOrganizacaoAtiva()?.assinatura?.organizacao_plano_id;
  }

  getOrganizacaoAuthorized() {
    return this.getOrganizacaoAtiva()?.authorized;
  }

  getOrganizacaoIsento() {
    return this.getOrganizacaoAtiva()?.isento;
  }

  get organizacaoCanChangePlan() {
    return true;
  }

  getRole() {
    let user = this.getObject(USER_KEY);
    if (!user) return;
    return user.role_name;
  }

  getUserRoleLevel() {
    let user = this.getObject(USER_KEY);
    if (!user) return;
    return user.role_level;
  }

  getUserPermissions() {
    let user = this.getObject(USER_KEY);
    if (!user) return [];
    return user.permissoes;
  }
}
